import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPageProps } from "@/types"
import type { FunctionComponent, ReactNode } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { CCTheme } from "@/modules/careerCenter/components/CCTheme"
import { Breadcrumbs } from "@/modules/companies/client/components/Breadcrumbs/Breadcrumbs"
import { Header } from "@/modules/companies/client/components/Header/Header"
import { Menu } from "@/modules/companies/client/components/Menu/Menu"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { FoLayout } from "@/modules/layouts/components/FoLayout"

import "react-loading-skeleton/dist/skeleton.css"

export const Wrapper: FunctionComponent<PagesRouterPageProps<WrapperProps & { children: ReactNode }>> = props => {
  const { children, host, serverContext } = props
  const { baseUrl } = serverContext || { baseUrl: "" }
  const { dataCompany } = useCompanyFetch()

  if (dataCompany) {
    return (
      <CCTheme>
        <FoLayout host={host}>
          <Layout hasTopPadding hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Header baseUrl={baseUrl} />
            </Layout.Column>
          </Layout>
          <Layout hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Menu />
            </Layout.Column>
          </Layout>
          {children}
          <Layout hasBottomPadding hasTopPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Breadcrumbs />
            </Layout.Column>
          </Layout>
        </FoLayout>
      </CCTheme>
    )
  }

  return null
}
